import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AppMenuitem } from './app.menuitem';
import { MenuService } from '../service/menu.service';

@Component({
    selector: 'app-menu',
    standalone: true,
    imports: [CommonModule, AppMenuitem, RouterModule],
    template: `<ul class="layout-menu">
        <ng-container *ngFor="let item of model; let i = index">
            <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
            <li *ngIf="item.separator" class="menu-separator"></li>
        </ng-container>
    </ul> `
})
export class AppMenu {
    model: MenuItem[] = [];
    hasSelectedDo: boolean = false;

    constructor(private menuService: MenuService) {
    this.menuService.menuUpdate$.subscribe(() => {
                this.checkSelectedDo();
                this.buildMenu();
            });
    }

    ngOnInit() {
        this.checkSelectedDo();
        this.buildMenu();
    }

     checkSelectedDo() {
        const savedDo = sessionStorage.getItem('selectedDo');
        this.hasSelectedDo = !!savedDo;
    }

    buildMenu() {
         this.model = [
            // {
            //     label: 'Home',
            //     items: [{ label: '', icon: 'pi pi-fw pi-home', routerLink: ['/'] }]
            // },
             {
                label: 'ACCEUIL',
                items: [{ label: 'Rechercher DO', icon: 'pi pi-fw pi-home', routerLink: ['/rechercher-do'],
                    outerLinkActiveOptions: { exact: true }
                 }]
            },
            {
                label: 'PANNEAUX D\'ADMINISTRATION',
                visible: this.hasSelectedDo, // Ne s'affiche que si une DO est sélectionnée
                items: [
                     { label: 'Gestion DO', icon: 'pi pi-fw pi-user', routerLink: ['/gestion-do'],
                        routerLinkActiveOptions: { exact: false },
                        disabled: !this.hasSelectedDo // Désactivé si aucune DO
                     },
                    { label: 'Gestion Annuaire', icon: 'pi pi-fw pi-address-book',
                        routerLink: ['/gestion-annuaire'],
                        routerLinkActiveOptions: { exact: false },
                        disabled: !this.hasSelectedDo
                     },
                    { label: 'Gestion Astreinte', icon: 'pi pi-fw pi-calendar',
                        routerLink: ['/gestion-astreinte'],
                        routerLinkActiveOptions: { exact: false },
                        disabled: !this.hasSelectedDo
                     }
                     ,
                     { label: 'Gestion Société', icon: 'pi pi-building',
                        routerLink: ['/gestion-societe'],
                        routerLinkActiveOptions: { exact: false },
                        disabled: !this.hasSelectedDo
                     },
                     { label: 'Gestion Contact', icon: 'pi pi-users',
                        routerLink: ['/gestion-contact'],
                        routerLinkActiveOptions: { exact: false },
                        disabled: !this.hasSelectedDo
                     },
                     { label: 'Gestion Dossier', icon: 'pi pi-folder-open',
                        routerLink: ['/gestion-dossier'],
                        routerLinkActiveOptions: { exact: false },
                        disabled: !this.hasSelectedDo
                     },

                      { label: 'Gestion Info & Libellés', icon: 'pi pi-info-circle',
                        routerLink: ['/gestion-info'],
                        routerLinkActiveOptions: { exact: false },
                        disabled: !this.hasSelectedDo
                     },

                     { label: 'Gestion Traitement', icon: 'pi pi-cog',
                        routerLink: ['/gestion-traitement'],
                        routerLinkActiveOptions: { exact: false },
                        disabled: !this.hasSelectedDo
                     },

                ]
            },

          // ici en trouve les sous pages des extractions des diffrents type of reporting
            {
              label: 'Reporting',
              items: [
                { label: 'Rapports Production', icon: 'pi pi-fw pi-database', routerLink: ['/extract-prod'] },
                { label: 'Rapports Clients', icon: 'pi pi-fw pi-database', routerLink: ['/extract-client'] },
                { label: 'Rapports Facturation', icon: 'pi pi-fw pi-database', routerLink: ['/extract-facturation'] },
                { label: 'Suivi Envois Rapports', icon: 'pi pi-fw pi-database', routerLink: ['/extract-admin'] },
                { label: 'Gestion Destinataires', icon: 'pi pi-fw pi-database', routerLink: ['/gestion-destinataires'] }

              ]
            },

            //   {
            //     label: 'Demo Template',
            //     items: [{ label: 'Demo', icon: 'pi pi-fw pi-home', routerLink: ['/demo'] }]
            // },
            /*{
                label: 'Pages',
                icon: 'pi pi-fw pi-briefcase',
                routerLink: ['/pages'],
                items: [
                    {
                        label: 'Landing',
                        icon: 'pi pi-fw pi-globe',
                        routerLink: ['/landing']
                    },
                    {
                        label: 'Auth',
                        icon: 'pi pi-fw pi-user',
                        items: [
                            {
                                label: 'Login',
                                icon: 'pi pi-fw pi-sign-in',
                                routerLink: ['/auth/login']
                            },
                            {
                                label: 'Error',
                                icon: 'pi pi-fw pi-times-circle',
                                routerLink: ['/auth/error']
                            },
                            {
                                label: 'Access Denied',
                                icon: 'pi pi-fw pi-lock',
                                routerLink: ['/auth/access']
                            }
                        ]
                    },
                    {
                        label: 'Crud',
                        icon: 'pi pi-fw pi-pencil',
                        routerLink: ['/pages/crud']
                    },
                    {
                        label: 'Not Found',
                        icon: 'pi pi-fw pi-exclamation-circle',
                        routerLink: ['/pages/notfound']
                    },
                    {
                        label: 'Empty',
                        icon: 'pi pi-fw pi-circle-off',
                        routerLink: ['/pages/empty']
                    }
                ]
            },
            {
                label: 'Hierarchy',
                items: [
                    {
                        label: 'Submenu 1',
                        icon: 'pi pi-fw pi-bookmark',
                        items: [
                            {
                                label: 'Submenu 1.1',
                                icon: 'pi pi-fw pi-bookmark',
                                items: [
                                    { label: 'Submenu 1.1.1', icon: 'pi pi-fw pi-bookmark' },
                                    { label: 'Submenu 1.1.2', icon: 'pi pi-fw pi-bookmark' },
                                    { label: 'Submenu 1.1.3', icon: 'pi pi-fw pi-bookmark' }
                                ]
                            },
                            {
                                label: 'Submenu 1.2',
                                icon: 'pi pi-fw pi-bookmark',
                                items: [{ label: 'Submenu 1.2.1', icon: 'pi pi-fw pi-bookmark' }]
                            }
                        ]
                    },
                    {
                        label: 'Submenu 2',
                        icon: 'pi pi-fw pi-bookmark',
                        items: [
                            {
                                label: 'Submenu 2.1',
                                icon: 'pi pi-fw pi-bookmark',
                                items: [
                                    { label: 'Submenu 2.1.1', icon: 'pi pi-fw pi-bookmark' },
                                    { label: 'Submenu 2.1.2', icon: 'pi pi-fw pi-bookmark' }
                                ]
                            },
                            {
                                label: 'Submenu 2.2',
                                icon: 'pi pi-fw pi-bookmark',
                                items: [{ label: 'Submenu 2.2.1', icon: 'pi pi-fw pi-bookmark' }]
                            }
                        ]
                    }
                ]
            },*/
            /*{
                label: 'Get Started',
                items: [
                   /* {
                        label: 'Documentation',
                        icon: 'pi pi-fw pi-book',
                        routerLink: ['/documentation']
                    },
                    {
                        label: 'View Source',
                        icon: 'pi pi-fw pi-github',
                        url: 'https://github.com/primefaces/sakai-ng',
                        target: '_blank'
                    },
                ]
            }*/


        ];
    }
}
